import { Navigate } from "react-router-dom";
import { Page } from "./config";
import { storage } from "../utils/storage";
import { useDispatch, useSelector } from "react-redux";
import { getIsLoggedIn, logOut, selectCurrentToken } from "../redux/features/auth/authSlice";
import { useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
}

export const ProtectedRoute = ({ children, redirectPath = Page.LOGIN }: ProtectedRouteProps) => {
  const location = useLocation();
  const dispatch = useDispatch();
    // const dispatch = useDispatch();
    // useEffect(() => {
    //     checkLoginSession();
    // }, []);
  
  // function checkLoginSession(){
  //   const interval = setInterval(() => {
  //     if(accessToken !== undefined && accessToken !== null && accessToken !== ""){
  //     let decoded:any = jwt_decode(accessToken);
  //     let expireTimestamp = decoded?.exp;
  //     let currentTimestamp = new Date().getTime()/1000;
  //       let isExpired = expireTimestamp > currentTimestamp ? false : true;
  //       if(isExpired) {
  //         dispatch(logOut());
  //       }
  //     }
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }
  
  // Allow auth from current Redux state and persisted/localStorage fallback.
  const reduxIsLoggedIn = useSelector(getIsLoggedIn);
  const reduxToken = useSelector(selectCurrentToken);
  const storedToken = storage.getToken();
  const token = reduxToken || storedToken;

  const isTokenExpired = (jwtToken?: string | null) => {
    if (!jwtToken) return false;
    try {
      const payloadPart = jwtToken.split(".")[1];
      if (!payloadPart) return false;
      const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
      const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
      const payload = JSON.parse(atob(padded));
      const exp = Number(payload?.exp);
      if (!Number.isFinite(exp)) return false;
      return Date.now() >= exp * 1000;
    } catch {
      return false;
    }
  };

  const tokenExpired = isTokenExpired(token);
  const isLoggedIn = Boolean((reduxIsLoggedIn || token) && !tokenExpired);

  if (tokenExpired) {
    dispatch(logOut({}));
    storage.clearAll();
  }
  
  if (!isLoggedIn) {
    console.warn("[Auth Debug] ProtectedRoute redirecting to login", {
      fromPath: location.pathname,
      search: location.search,
      redirectPath,
      reduxIsLoggedIn,
      hasReduxToken: Boolean(reduxToken),
      hasStoredToken: Boolean(storedToken),
      tokenExpired,
    });
    return <Navigate to={redirectPath} replace />;
  }
  
  return <>{children}</>;
};
  
